/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyLeu = createReactComponent("outline", "currency-leu", "IconCurrencyLeu", [["path", { "d": "M17 18h-7a3 3 0 0 1 -3 -3v-10", "key": "svg-0" }]]);

export { IconCurrencyLeu as default };
//# sourceMappingURL=IconCurrencyLeu.mjs.map
